import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { Router } from '@angular/router';
import { GUID } from '@barthauer/abc/core';
import {
  DataService as CoreDataService,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
} from '@barthauer/abc/core/data';
import { _AbcContextMenuComponent, _AbcGridComponent } from '@barthauer/abc/ui-components';
import { DefaultIcons, MeasureTask, Person } from '@barthauer/custom/xmt-models';
import {
  DxCheckBoxModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxRadioGroupModule,
  DxTreeListModule,
} from 'devextreme-angular';
import { Column } from 'devextreme/ui/data_grid';
import { Observable, Subscription } from 'rxjs';
import { finalize, map, switchMap } from 'rxjs/operators';
import { ObjectTypeNames } from '../../../favorite-list/favorite-list.component';
import { NotificationMessage, ROLES, ToastType } from '../../../models/enumeration-list.model';
import { AppService } from '../../../services/app.service';
import { DataService, ObjectKeys } from '../../../services/data.service';
import { NotificationService } from '../../../services/notification.service';
import { FavoritesService } from '../../../shared/favorite/favorites.service';
import { BoxDetailViewModel } from '../../../shared/favorite/Model/box.viewModel';
import { SharedModule } from '../../../shared/shared.module';
import { IcontextMenuItems, IDescription, ILookup, StateFavorite } from '../measure.model';
import { MeasureTaskService } from './measure-task.service';
import { Breakpoints } from '@angular/cdk/layout';
import { BasedRoleOPathService } from '../../../services/based-role-opath.service';

@Component({
  selector: 'ubt-geods-measure-task',
  templateUrl: './measure-task.component.html',
  styleUrls: ['./measure-task.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DxTreeListModule,
    DxRadioGroupModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    _AbcGridComponent,
    DxDataGridModule,
    FlexModule,
    SharedModule,
    _AbcContextMenuComponent,
  ],
})
export class MeasureTaskComponent implements OnInit, OnDestroy {
  @ViewChild('contextMenu') contextMenu: _AbcContextMenuComponent;
  private readonly VISIBLE_TASKS_COLUMNS = [
    'Subject',
    'Description',
    'IdRefResponsible',
    'StartDate',
    'EndDate',
    'TotalTimeRequired',
    'Collaborators',
  ];
  private readonly HIDDEN_TASKS_COLUMNS = [
    'Type',
    'IdRefxmtMeasureTask',
    'FinishedOn',
    'TargetMaturityLevel',
    'DegreeOfImplementation',
  ];
  public columnsHeader: Column[] = [
    {
      dataField: 'SubProject',
      caption: this.dataService.res('Ubt-Measure-List-SubProject'),
      visible: true,
      groupIndex: 0,
      autoExpandGroup: true,
    },
    {
      dataField: 'Measure',
      caption: this.dataService.res('Company-Measures'),
      visible: true,
      groupIndex: 1,
      autoExpandGroup: true,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-Subject'),
      dataField: 'Subject',
      visibleIndex: 0,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-Description'),
      dataField: 'Description',
      visibleIndex: 1,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-IdRefResponsible'),
      dataField: 'IdRefResponsible',
      visibleIndex: 2,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-Start-Date'),
      dataField: 'StartDate',
      visibleIndex: 3,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-EndDate'),
      dataField: 'EndDate',
      visibleIndex: 4,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-TotalTimeRequired'),
      dataField: 'TotalTimeRequired',
      visibleIndex: 5,
    },
  ];
  private subscriptions: Subscription[] = [];
  public measureTasks: MeasureTask[] = [];
  public measureTaskTitle: String;
  private currentProfileId: string;
  private myTasks = true;
  private myMilestones = true;
  public tasksTitle = this.dataService.res('Ubt-Measure-My-Tasks');
  public milestonesTitle = this.dataService.res('Ubt-Measure-My-Milestone');
  public  ROLES=ROLES
  @ViewChild('measureGrid') measureGrid: _AbcGridComponent;
  private prepareProfileId(): Observable<Person[]> {
    const profileColumns = [this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None)];
    const companyId = localStorage.getItem('currentCompany');
    const userNameLogin = sessionStorage.getItem('userName');
    const profileOPath = ` Login='${userNameLogin}' AND ParentId='${companyId}'`;
    return this.dataService.readObjects<Person[]>(ObjectKeys.PERSON, profileColumns, profileOPath);
  }
  public measureTask: MeasureTask = new MeasureTask(null);
  public noDataText = this.dataService.res('Ubt-No-Data-text');
  private collaboratorList: ILookup[] = [];

  constructor(
    public dataService: DataService,
    private coreDataService: CoreDataService,
    public appService: AppService,
    public measureTaskService: MeasureTaskService,
    public favoritesService: FavoritesService,
    private notificationService: NotificationService,
    private router: Router,
    private  opathService:BasedRoleOPathService
  ) {}
  public contextMenuItems: IcontextMenuItems[];
  public ngOnInit(): void {
    this.measureTaskTitle = this.dataService.res('Ubt-TreeList-Milestones-Tasks');
    this.appService.showLoader(true);

    this.subscriptions.push(
      this.dataService
        .prepareStaffMembers()
        .pipe(
          switchMap((staffMembers) => {
            if (Array.isArray(staffMembers) && staffMembers.length > 0) {
              this.dataService.cachedResponsiblesResponse = staffMembers;
            }
            return this.coreDataService.executeReadObjectTypeInfo({ ObjectTypeName: ObjectKeys.TASK }).pipe(
              switchMap((layoutStructure: any) => {
                layoutStructure.Columns.forEach((column) => {
                  const existingColumnIndex = this.columnsHeader.findIndex((c) => c.dataField === column.Name);

                  if (existingColumnIndex !== -1) {
                    this.columnsHeader[existingColumnIndex] = {
                      ...this.columnsHeader[existingColumnIndex],
                      dataType: this.dataService.getDataType(column.DataType),
                      format:
                        this.dataService.getDataType(column.DataType) === 'number'
                          ? '#,##0 h'
                          : this.dataService.getDataType(column.DataType) === 'date'
                          ? 'dd.MM.yyyy'
                          : null,
                      visibleIndex: this.VISIBLE_TASKS_COLUMNS.indexOf(column.Name),
                      visible: this.VISIBLE_TASKS_COLUMNS.includes(column.Name) ? true : false,
                      showInColumnChooser:
                        !this.appService.CONFIG_PROPERTIES.includes(column.Name) &&
                        !this.HIDDEN_TASKS_COLUMNS.includes(column.Name)
                          ? true
                          : false,
                      lookup: this.getLookupColumn(column.Name),
                    };
                  } else {
                    this.columnsHeader.push({
                      dataField: column.Name,
                      caption: this.dataService.res('Ubt-MeasureTask-' + column.DisplayText),
                      dataType: this.dataService.getDataType(column.DataType),
                      format:
                        this.dataService.getDataType(column.DataType) === 'number'
                          ? '#,##0 h'
                          : this.dataService.getDataType(column.DataType) === 'date'
                          ? 'dd.MM.yyyy'
                          : null,
                      visibleIndex: this.VISIBLE_TASKS_COLUMNS.indexOf(column.Name),
                      visible: this.VISIBLE_TASKS_COLUMNS.includes(column.Name) ? true : false,
                      showInColumnChooser:
                        !this.appService.CONFIG_PROPERTIES.includes(column.Name) &&
                        !this.HIDDEN_TASKS_COLUMNS.includes(column.Name)
                          ? true
                          : false,
                      lookup: this.getLookupColumn(column.Name),
                    });
                  }
                });
                this.subscriptions.push(
                  this.prepareProfileId().subscribe((currentProfile) => {
                    this.currentProfileId = currentProfile[0] ? currentProfile[0].Id : '';
                  })
                );
                return this.coreDataService
                  .executeReadObjectsQuery(this.prepareMeasureTaskColumns())
                  .pipe(map((tasks) => tasks));
              })
            );
          }),
          finalize(() => {
            this.columnsHeader.push(
              {
                dataField: 'CollaboratorsDisplay',
                caption: this.dataService.res('Ubt-CreateMeasureTask-Collaborators'),
                visible: true,
                width: '200px',
                lookup: {
                  dataSource: this.collaboratorList,
                  displayExpr: 'Name',
                  valueExpr: 'Value',
                },
                filterOperations: ['contains'],
              },
              {
                dataField: 'Collaborators',
                caption: this.dataService.res('Ubt-CreateMeasureTask-Collaborators'),
                visible: false,
              },
              {
                type: 'buttons',
                caption: '',
                alignment: 'left',
                minWidth: 50,
                width: '50px',
                dataField: '',
              }
            );
          })
        )
        .subscribe(
          (tasks) => {
            if (Array.isArray(tasks) && tasks.length > 0) {
              tasks.sort((a, b) => {
                return a.Subject.localeCompare(b.Subject);
              });
              tasks.forEach((task, index) => {
                const _collaboratorList: string[] = (task.Collaborators || [])
                  .map((collaborator) => collaborator.MeasureResources?.find(Boolean)?.Person)
                  .filter(Boolean);

                tasks[index].CollaboratorsDisplay = _collaboratorList;

                _collaboratorList?.forEach((collaborator) => {
                  if (this.collaboratorList.findIndex((element) => element.Value === collaborator) === -1)
                    this.collaboratorList.push({
                      Value: collaborator,
                      Name: collaborator,
                    });
                });
              });
              this.measureTasks = tasks;
            } else {
              this.notificationService.callNotification({ message: NotificationMessage.Empty, type: ToastType.INFO });
            }
          },
          (error) => {
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
            this.appService.showLoader(false);
            console.error(error);
          },
          () => {
            this.appService.showLoader(false);
          }
        )
    );
    this.contextMenuItems = [
      {
        key: 'IsEdit',
        text: this.getTextMenu('IsEdit'),
        onClick: () => {
          this.editMeasureTask();
        },
      },
      {
        key: 'IsFavorite',
        text: this.getTextMenu('IsEdit'),
        onClick: () => {
          this.updateFavorite();
        },
      },
    ];
  }

  private getLookupColumn(key: string) {
    switch (key) {
      case 'IdRefResponsible':
        return {
          valueExpr: 'Id',
          displayExpr: this.dataService.getResponsibleFullName,
          dataSource: this.dataService.cachedResponsiblesResponse.sort((a, b) => a.LastName.localeCompare(b.LastName)),
        };
      case 'TargetMaturityLevel':
        return { valueExpr: 'name', displayExpr: 'value', dataSource: this.measureTaskService.maturityLevel };
      case 'Description': {
        const description: IDescription[] = [
          {
            value: 0,
            name: this.dataService.res('Ubt-MeasureDetail-Milestone'),
          },
          { value: 1, name: this.dataService.res('Ubt-MeasureDetail-Task') },
        ];
        return { valueExpr: 'value', displayExpr: 'name', dataSource: description };
      }
    }
  }

  public onCellPrepared = (e): void => {
    if (e.rowType === 'header') {
      e.cellElement.style.textAlign = 'left';
    }
    if (e.rowType === 'data') {
      if (e.column.dataField === 'Subject') {
        e.cellElement.style.height = 100;
        e.cellElement.style.overflowWrap = 'break-word';
        e.cellElement.style.fontWeight = 700;
      }
      if (e.column.dataField === 'DegreeOfImplementation') {
        this.textTransform(e);
        e.cellElement.append('%');
      }
      if (e.column.dataField === 'Description') {
        if (e.data?.Type === 0) {
          e.cellElement.innerText = this.dataService.res('Ubt-MeasureDetail-Milestone');
        } else {
          e.cellElement.innerText = this.dataService.res('Ubt-MeasureDetail-Task');
        }
      }
      if (e.column.dataField === 'CollaboratorsDisplay') {
        e.cellElement.classList.add('display-collaborators');
        return (e.cellElement.innerHTML = (e.data.Collaborators || [])
          .map((collaborator) => collaborator.MeasureResources?.find(Boolean)?.Person)
          .filter(Boolean)
          .join('<br>'));
      }
      if (e.column.type === 'buttons') {
        e.cellElement.style.cursor = 'pointer';
        e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
      }
    }
  };

  public onCellClick(e: any): void {
    this.measureTask = e.data;
    if (e.rowType === 'data') {
      if (e.column.type === 'buttons') {
        e.cellElement.className = 'context-menu-icon' + e.rowIndex;
        e.cellElement.innerHTML = this.contextMenu.visible ? DefaultIcons.CLOSE : DefaultIcons.CONTEXTMENU;
        this.onLoadContextMenuItem('IsFavorite');
        this.onLoadContextMenuItem('IsEdit');
        this.contextMenu.target = '.context-menu-icon' + e.rowIndex;
        this.contextMenu.instance.show();
      }
    }
  }

  private onLoadContextMenuItem = (key: string): void => {
    const ContextMenuItemIndex = this.contextMenuItems.findIndex((element) => {
      return element.key === key;
    });
    this.contextMenuItems[ContextMenuItemIndex].text = this.getTextMenu(key);
  };

  private getTextMenu = (key: string): string => {
    let textMenu = '';
    switch (key) {
      case 'IsEdit': {
        textMenu = this.dataService.res(
          'Ubt-MeasureTask-' + (this.measureTask.Type === 0 ? 'EditMilestone' : 'EditTask')
        );
        break;
      }
      case 'IsFavorite': {
        textMenu =
          this.measureTask['IsFavorite'] === 1
            ? this.dataService.res('Ubt-SubProject-Remove-from-favorites')
            : this.dataService.res('Ubt-SubProject-Add-to-favorites');
        break;
      }
    }

    return textMenu;
  };

  private editMeasureTask(): void {
    const measureTaskToEdit = new MeasureTask(this.measureTask);
    measureTaskToEdit.Label = this.measureTask.Subject;
    measureTaskToEdit.Responsible = this.measureTask.IdRefResponsible;

    this.appService.setMeasureTask(measureTaskToEdit);
    this.router.navigate(['measureDetail', 'measures', measureTaskToEdit.ParentId]);
  }
   private addMeasureTaskToFavorite(){
    const measureTaskToEdit = new MeasureTask(this.measureTask);
    measureTaskToEdit.Label = this.measureTask.Subject;
    measureTaskToEdit.Responsible = this.measureTask.IdRefResponsible;

    this.appService.setMeasureTask(measureTaskToEdit);
   }
  private updateFavorite(): void {
    if (this.measureTask['IsFavorite'] === 1) {
      return this.deleteFavorite();
    } else {
      return this.addFavorite();
    }
  }
   
  public addFavorite(): void {
   
   
   const concatenatedString = `${this.measureTask['ParentLabel']}  / ${this.measureTask.Subject}`;
   this.subscriptions.push(
      this.favoritesService
        .persistFavoriten(GUID.newGUID(), ObjectTypeNames.MeasureTask, this.measureTask.Id, concatenatedString)
        .subscribe((data) => {
          this.measureTasksUpdateState(this.measureTask, StateFavorite.ADD, data);
          this.addMeasureTaskToFavorite()
        })
    );
  }

  public deleteFavorite(): void {
    this.favoritesService.deleteFavoriten(this.measureTask['BoxDetailId']);
    this.measureTasksUpdateState(this.measureTask, StateFavorite.DELETE);
  }

  public measureTasksUpdateState(e: MeasureTask, state: string, favoriteData?: BoxDetailViewModel): void {
    const selectedIndex = this.measureTasks.findIndex((measureTask) => measureTask.Id === e.Id);
    if (state === StateFavorite.ADD) {
      this.measureTasks[selectedIndex] = { ...e, IsFavorite: 1, BoxDetailId: favoriteData.Id };
      this.notificationService.callNotification({
        message: NotificationMessage.AddToFavorite,
        type: ToastType.SUCCESS,
      });
    } else if (state === StateFavorite.DELETE) {
      this.measureTasks[selectedIndex] = { ...e, IsFavorite: 0 };
      this.notificationService.callNotification({
        message: NotificationMessage.RemovedFromFavorite,
        type: ToastType.SUCCESS,
      });
    }
  }

  public textTransform(e): void {
    if (e.text === '') {
      e.cellElement.append(0);
    }
  }
  public checkMeaureTaskOpath():string{
   return  this.opathService.checkMeasureTaskOPath()
  }
 
  private prepareMeasureTaskColumns(): QueryObjectsModel {
    const measureTask: Query = new Query();
    const measureTaskColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('ParentId', 'ParentId'),
      this.coreDataService.createQueryColumn('!.Designation', 'ParentLabel'),
      this.coreDataService.createQueryColumn('Subject', 'Subject'),
      this.coreDataService.createQueryColumn('StartDate', 'StartDate'),
      this.coreDataService.createQueryColumn('EndDate', 'EndDate'),
      this.coreDataService.createQueryColumn('TotalTimeExecuted', 'TotalTimeExecuted'),
      this.coreDataService.createQueryColumn('DegreeOfImplementation', 'DegreeOfImplementation'),
      this.coreDataService.createQueryColumn('IdRefResponsible', 'IdRefResponsible'),
      this.coreDataService.createQueryColumn('TargetMaturityLevel', 'TargetMaturityLevel'),
      this.coreDataService.createQueryColumn('TotalTimeRequired', 'TotalTimeRequired'),
      this.coreDataService.createQueryColumn('Type', 'Type'),
      this.coreDataService.createQueryColumn('Status', 'Status'),
      this.coreDataService.createQueryColumn('Type', 'Description'),
      this.coreDataService.createQueryColumn('!.!.Designation', 'SubProject'),
      this.coreDataService.createQueryColumn('!.Designation', 'Measure', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn(
        "Exists(Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id])",
        'IsFavorite'
      ),
      this.coreDataService.createQueryColumn(
        "Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id].Id",
        'BoxDetailId'
      ),
    ];
    measureTask.ObjectType = ObjectKeys.TASK;
    measureTask.Columns = measureTaskColumns;
    measureTask.OPath = this.checkMeaureTaskOpath();
    measureTask.Columns.push(this.coreDataService.createQueryColumn('IdRefxmtMeasureTask', 'Task'));

    const measureResources: Query = new Query();
    measureResources.Name = 'MeasureResources';
    measureResources.OPath = 'MeasureResource';
    const measureResourcesColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('IdRefPerson', 'Member'),
      this.coreDataService.createQueryColumn('ref:IdRefPerson', 'Person'),
    ];
    measureResources.Columns = measureResourcesColumns;

    const taskCollaborators: Query = new Query();
    taskCollaborators.Name = 'Collaborators';
    taskCollaborators.OPath = 'collaborators';
    const taskCollaboratorsColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('ParentId', 'ParentId'),
      this.coreDataService.createQueryColumn('TimePlanned', 'TimePlanned'),
      this.coreDataService.createQueryColumn('TimeExecuted', 'TimeExecuted'),
      this.coreDataService.createQueryColumn('IdRefMeasureResource', 'IdRefMember'),
    ];
    taskCollaborators.Columns = taskCollaboratorsColumns;
    taskCollaborators.ObjectQueries = [measureResources];
    measureTask.ObjectQueries = [taskCollaborators];
    const measureDetailColumns = new QueryObjectsModel();
    measureDetailColumns.ObjectQueries = [measureTask];
    return measureDetailColumns;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
  loadMyMeasureTasks() {
    if (this.myTasks) {
      const myTasks = this.measureTasks.filter((task) => {
        return task['IdRefResponsible'] === this.currentProfileId && +task.Description === 1;
      });

      if (Array.isArray(myTasks) && myTasks.length > 0) {
        this.measureGrid.dataSource = myTasks;
        this.tasksTitle = this.dataService.res('Ubt-Measure-All-Tasks');
      } else {
        this.notificationService.callNotification({ message: NotificationMessage.Empty, type: ToastType.INFO });
      }
    } else {
      this.measureGrid.dataSource = this.measureTasks;
      this.tasksTitle = this.dataService.res('Ubt-Measure-My-Tasks');
      this.milestonesTitle = this.dataService.res('Ubt-Measure-My-Milestone');
      this.myMilestones = true;
    }
    this.myTasks = !this.myTasks;
  }

  loadMyMeasureMilestones() {
    if (this.myMilestones) {
      const myMilestones = this.measureTasks.filter((milestone: MeasureTask) => {
        return milestone['IdRefResponsible'] === this.currentProfileId && +milestone.Description === 0;
      });
      if (Array.isArray(myMilestones) && myMilestones.length > 0) {
        this.measureGrid.dataSource = myMilestones;
        this.milestonesTitle = this.dataService.res('Ubt-Measure-All-Milestone');
      } else {
        this.notificationService.callNotification({ message: NotificationMessage.Empty, type: ToastType.INFO });
      }
    } else {
      this.measureGrid.dataSource = this.measureTasks;
      this.milestonesTitle = this.dataService.res('Ubt-Measure-My-Milestone');
      this.tasksTitle = this.dataService.res('Ubt-Measure-My-Tasks');
      this.myTasks = true;
    }
    this.myMilestones = !this.myMilestones;
  }
}
